// removed by extract-text-webpack-plugin
module.exports = {"table":"_2oEcL_2o"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Parcel/components/Information/CourierInformationTable/CourierInformationTable.css
// module id = 765
// module chunks = 0